var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSearch = function SvgSearch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Search_svg__a",
    width: 19,
    height: 19,
    x: 2.2,
    y: 2.2,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.2 2.2h19v19h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.6 10.4a6.2 6.2 0 1 1-12.4 0 6.2 6.2 0 0 1 12.4 0m-1.475 5.432a7.2 7.2 0 1 1 .707-.707l4.522 4.521a.5.5 0 1 1-.708.708z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.6 10.4a6.2 6.2 0 1 1-12.4 0 6.2 6.2 0 0 1 12.4 0m-1.475 5.432a7.2 7.2 0 1 1 .707-.707l4.522 4.521a.5.5 0 1 1-.708.708z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.125 15.833.354-.354-.33-.33-.352.306zm.707-.708-.377-.328-.306.352.33.33zm4.522 4.522L20 20zm0 .707L20 20zm-.708 0L20 20zM10.4 17.1c3.7 0 6.7-3 6.7-6.7h-1a5.7 5.7 0 0 1-5.7 5.7zm-6.7-6.7c0 3.7 3 6.7 6.7 6.7v-1a5.7 5.7 0 0 1-5.7-5.7zm6.7-6.7c-3.7 0-6.7 3-6.7 6.7h1a5.7 5.7 0 0 1 5.7-5.7zm6.7 6.7c0-3.7-3-6.7-6.7-6.7v1a5.7 5.7 0 0 1 5.7 5.7zm-6.7 7.7a7.67 7.67 0 0 0 5.054-1.89l-.657-.755A6.67 6.67 0 0 1 10.4 17.1zm-7.7-7.7a7.7 7.7 0 0 0 7.7 7.7v-1c-3.7 0-6.7-3-6.7-6.7zm7.7-7.7a7.7 7.7 0 0 0-7.7 7.7h1c0-3.7 3-6.7 6.7-6.7zm7.7 7.7a7.7 7.7 0 0 0-7.7-7.7v1c3.7 0 6.7 3 6.7 6.7zm-1.89 5.054A7.67 7.67 0 0 0 18.1 10.4h-1c0 1.683-.62 3.22-1.645 4.397zm-.731.025L20 20l.707-.707-4.52-4.521zM20 20l.707.707a1 1 0 0 0 0-1.414zm0 0-.707.707a1 1 0 0 0 1.414 0zm0 0-4.521-4.521-.707.707 4.52 4.521z",
    mask: "url(#Search_svg__a)"
  })));
};
export default SvgSearch;